import { storeSingleton } from 'src/client/store/storeSingleton';
import { selectDesktopOs } from 'src/common/selectors/app';
import { MAC_DESKTOP_OS } from '../../constants/desktop';
import vars, {
  GA_PROPERTY_ID,
  GA_PROPERTY_ID_MAC_DESKTOP,
  GA_PROPERTY_ID_WINDOWS_DESKTOP,
} from '../../vars';

export function getGoogleAnalyticsProperty() {
  const desktopOS = selectDesktopOs(storeSingleton.state);

  if (desktopOS) {
    return vars.get(
      desktopOS === MAC_DESKTOP_OS ? GA_PROPERTY_ID_MAC_DESKTOP : GA_PROPERTY_ID_WINDOWS_DESKTOP,
    );
  }

  return vars.get(GA_PROPERTY_ID);
}
